import { motion } from "framer-motion";
import useElementSize from "src/hooks/useElementSize";
import { cn } from "src/lib/utils";

interface StepsProps {
	max: number;
	current: number;
	className?: string;
	onChange?: (step: number) => void;
	theme?: {
		item?: {
			active?: string;
			inactive?: string;
		};
	};
}

const Steps = ({ max, current, className, onChange, theme }: StepsProps) => {
	const wrapper = useElementSize();
	const gap = 8 * max;
	const activeWidth = (wrapper.size.width - gap) / max;
	return (
		<div
			ref={wrapper.ref}
			className={cn("flex gap-2 items-center", className)}
		>
			{new Array(max).fill("").map((value, index) => (
				<Item
					key={`steps-${index}`}
					{...{ index, current, activeWidth }}
					theme={theme?.item}
					onClick={onChange ? () => onChange(index) : undefined}
				/>
			))}
		</div>
	);
};

interface ItemProps {
	index: number;
	current: number;
	activeWidth: number;
	onClick?: () => void;
	theme?: {
		active?: string;
		inactive?: string;
	};
}

const Item = ({ index, current, activeWidth, onClick, theme }: ItemProps) => {
	return (
		<motion.div
			className={cn(
				"h-2 w-8 flex rounded-full bg-accent overflow-hidden transition-all",
				onClick && "cursor-pointer hover:bg-accent-dark",
				theme?.inactive
			)}
			{...{ onClick }}
			transition={{
				ease: "linear",
			}}
			animate={index === current ? "active" : "inactive"}
			variants={{
				active: {
					width: activeWidth,
				},
				inactive: {
					width: "32px",
				},
			}}
		>
			<motion.div
				animate={current >= index ? "visible" : "hidden"}
				className={cn("flex-1 bg-dark", theme?.active)}
				variants={{
					visible: {
						opacity: 1,
					},
					hidden: {
						opacity: 0,
					},
				}}
			/>
		</motion.div>
	);
};

export default Steps;
